module.exports = __webpack_public_path__ + "static/twe-logo-2eab11034f0d2b72fb0e3ab73c05b26a.png";